import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgEdit" data-sentry-source-file="edit.tsx">
    <g clipPath="url(#edit_svg__a)" data-sentry-element="g" data-sentry-source-file="edit.tsx">
      <path fill="#263E6A" d="M5.308 19H6.38l9.894-9.894-1.073-1.073-9.894 9.894zM18.415 8.387l-2.5-2.489 1.208-1.208a1 1 0 0 1 .73-.305q.424 0 .73.305l1.034 1.035q.306.306.312.724a.97.97 0 0 1-.3.724zm-.719.725L6.808 20h-2.5v-2.5L15.196 6.612zM15.73 8.56l-.527-.527 1.073 1.073z" data-sentry-element="path" data-sentry-source-file="edit.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="edit.tsx">
      <clipPath id="edit_svg__a" data-sentry-element="clipPath" data-sentry-source-file="edit.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="edit.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgEdit;